export default function SeminarTopics() {
  const topics = [
    'なぜ、低与信市場は900万人規模まで膨れ上がっているのか？',
    '他社が次々と撤退する中、なぜリトラストだけが生き残ったのか？',
    '回収率0.5％を維持できる具体構造とは？',
    '車両アセット化の仕組みとは？',
    '今回の募集枠に関する具体的な参加条件と、優先案内の受け取り方について'
  ];

  return (
    <section className="py-20 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-8 md:px-16">
        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#1A2B4A] leading-tight mb-6 font-serif">
            90分で、あなたの「資産運用」の常識が変わる。<br />
            <span className="text-3xl md:text-4xl">セミナーで公開する5つのトピック</span>
          </h2>
          <div className="w-28 h-1 mx-auto mt-8" style={{
            background: 'repeating-linear-gradient(90deg, #D4AF37 0, #D4AF37 15px, transparent 15px, transparent 30px)',
          }}></div>
        </div>

        {/* Topics List */}
        <div className="space-y-6">
          {topics.map((topic, index) => (
            <div 
              key={index}
              className="group bg-white border-2 border-[#1A2B4A] rounded-2xl p-6 md:p-8 hover:shadow-xl hover:border-[#D4AF37] transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-6">
                {/* Number Badge */}
                <div className="w-16 h-16 flex items-center justify-center bg-[#D4AF37] text-white font-black text-2xl flex-shrink-0 group-hover:scale-110 transition-transform duration-300 font-serif">
                  {index + 1}
                </div>

                {/* Topic Text */}
                <div className="flex-1 pt-3">
                  <p className="text-lg md:text-xl text-gray-700 leading-relaxed font-medium font-serif">
                    {topic}
                  </p>
                </div>

                {/* Arrow Icon */}
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-arrow-right-line text-[#D4AF37] text-3xl"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-[#F8F9FA] to-[#E8EAF0] p-8 rounded-2xl shadow-lg max-w-3xl">
            <i className="ri-lightbulb-flash-line text-[#D4AF37] text-5xl mb-4"></i>
            <p className="text-xl font-bold text-[#1A2B4A] mb-3 font-serif">
              セミナーでは、これらのトピックを詳細に解説
            </p>
            <p className="text-base text-gray-600 leading-relaxed font-serif">
              単なる表面的な説明ではなく、実際の数字とデータに基づいた具体的な内容をお伝えします。質疑応答の時間も設けておりますので、疑問点はその場で解消できます。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
